import(/* webpackMode: "eager" */ "/app/src/components/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Col/Col.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Poland/About.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Poland/AboutPlatform.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Poland/Benefits.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Poland/InsightsVideos.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Poland/Intro.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Poland/SignupForm.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReadingRoom/ReadingRoom.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Row/Row.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Spacer/Spacer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Speakers/Speakers.js");
;
import(/* webpackMode: "eager" */ "/app/src/contexts/ModalProvider.js");
